<svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="43" cy="43" r="43" fill="currentColor"/>
<path d="M27.1 41L23 45L37.35 59L64 33L59.9 29L37.35 51L27.1 41Z" fill="white"/>
</svg>
